<template>
  <nav class="pager">
    <button type="button" class="pager-btn" :disabled="page <= 1" @click="emitChange(page - 1)">上一页</button>

    <div class="pager-nums">
      <template v-if="showHeadEllipsis">
        <button
            type="button"
            :class="['pager-num', { active: page === 1 }]"
            @click="emitChange(1)"
        >1</button>
        <button type="button" class="pager-num pager-ellipsis" disabled>…</button>
      </template>
      <button
          v-for="p in visiblePages"
          :key="p"
          type="button"
          :class="['pager-num', { active: p === page }]"
          @click="emitChange(p)"
      >{{ p }}</button>
      <template v-if="showTailEllipsis">
        <button type="button" class="pager-num pager-ellipsis" disabled>…</button>
        <button
            type="button"
            :class="['pager-num', { active: page === total }]"
            @click="emitChange(total)"
        >{{ total }}</button>
      </template>
    </div>

    <button type="button" class="pager-btn" :disabled="page >= total" @click="emitChange(page + 1)">下一页</button>

    <div class="pager-jump">
      <span class="pager-total">共 {{ total }} 页</span>
      <label class="pager-jump-label">
        <span>跳至</span>
        <input
            v-model="jumpInput"
            type="number"
            min="1"
            :max="total"
            class="pager-jump-input"
            @keyup.enter="jump"
        />
        <span>页</span>
      </label>
      <button type="button" class="pager-jump-btn" @click="jump">确定</button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'PagerBar',
  props: {
    page: { type: Number, required: true },
    total: { type: Number, required: true }
  },
  data() {
    return {
      jumpInput: '',
      maxVisible: 7
    }
  },
  computed: {
    visiblePages() {
      const total = this.total
      const current = this.page
      const maxShow = this.maxVisible
      if (total <= maxShow) {
        return Array.from({ length: total }, (_, i) => i + 1)
      }
      // 预留首尾页码位：1 … [窗口] … total
      const windowSize = Math.max(1, maxShow - 2)
      let start = Math.max(2, current - Math.floor(windowSize / 2))
      let end = Math.min(total - 1, start + windowSize - 1)
      start = Math.max(2, end - windowSize + 1)
      // 靠近首页时从 1 连续排，尾部留给 … total
      if (start <= 2) {
        start = 1
        end = Math.min(total - 1, windowSize)
      }
      // 靠近末页时连续排到 total，头部留给 1 …
      if (end >= total - 1) {
        end = total
        start = Math.max(1, total - windowSize + 1)
      }
      return Array.from({ length: end - start + 1 }, (_, i) => start + i)
    },
    showHeadEllipsis() {
      const pages = this.visiblePages
      return pages.length > 0 && pages[0] > 1
    },
    showTailEllipsis() {
      const pages = this.visiblePages
      return pages.length > 0 && pages[pages.length - 1] < this.total
    }
  },
  watch: {
    page(val) {
      this.jumpInput = String(val)
    }
  },
  mounted() {
    this.jumpInput = String(this.page)
    this.updateMaxVisible()
    window.addEventListener('resize', this.updateMaxVisible)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMaxVisible)
  },
  methods: {
    updateMaxVisible() {
      this.maxVisible = window.innerWidth <= 600 ? 5 : 7
    },
    emitChange(p) {
      if (p < 1 || p > this.total || p === this.page) return
      this.$emit('change', p)
    },
    jump() {
      let p = parseInt(this.jumpInput, 10)
      if (isNaN(p)) return
      if (p < 1) p = 1
      if (p > this.total) p = this.total
      this.jumpInput = String(p)
      this.emitChange(p)
    }
  }
}
</script>
